import _styled from "@emotion/styled/base";
import { cellBasic } from '../Td/Td';
export var Th = /*#__PURE__*/_styled("th", true ? {
  target: "e1488we50"
} : {
  target: "e1488we50",
  label: "Th"
})(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textBoldSmall;
}, ";", cellBasic, " background-color:inherit;text-align:left;text-align:", function (_ref2) {
  var align = _ref2.align;
  return align;
}, ";vertical-align:", function (_ref3) {
  var vAlign = _ref3.vAlign;
  return vAlign;
}, ";", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.h6;
}, ";min-width:160px;}" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvVGFibGVCYXNpYy9UaC9UaC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3NDIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvVGFibGVCYXNpYy9UaC9UaC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IHR5cGUgeyBDZWxsUHJvcHMgfSBmcm9tICcuLi9UZC9UZCdcbmltcG9ydCB7IGNlbGxCYXNpYyB9IGZyb20gJy4uL1RkL1RkJ1xuXG5leHBvcnQgY29uc3QgVGggPSBzdHlsZWQudGg8Q2VsbFByb3BzPmBcbiAgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50eXBvZ3JhcGh5LnRleHRCb2xkU21hbGx9O1xuICAke2NlbGxCYXNpY31cblxuICBiYWNrZ3JvdW5kLWNvbG9yOiBpbmhlcml0O1xuXG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIHRleHQtYWxpZ246ICR7KHsgYWxpZ24gfSkgPT4gYWxpZ259O1xuICB2ZXJ0aWNhbC1hbGlnbjogJHsoeyB2QWxpZ24gfSkgPT4gdkFsaWdufTtcblxuICAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmJyZWFrcG9pbnRzLnVwKGBzbWApfSB7XG4gICAgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50eXBvZ3JhcGh5Lmg2fTtcbiAgICBtaW4td2lkdGg6IDE2MHB4O1xuICB9XG5gXG4iXX0= */"));